module.exports = __webpack_public_path__ + "static/media/infoJumbo2.f965b2c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/davi/images/infoJumbo2.jpg
// module id = 511
// module chunks = 0